export default "__VITE_ASSET__DE4We9n5__"